module.exports = {"632701001":"结古街道","632701002":"扎西科街道","632701003":"西杭街道","632701004":"新寨街道","632701101":"隆宝镇","632701102":"下拉秀镇","632701200":"仲达乡","632701201":"巴塘乡","632701202":"小苏莽乡","632701203":"上拉秀乡","632701205":"安冲乡","632701400":"哈秀乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632701.json
// module id = 3152
// module chunks = 0